export default __webpack_public_path__ + "locales/ar-SA/Settings.json?hash=4aee260c32f82aa6afc95165006ca64a";